// AI Generated Test
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { API_CONSTANTS } from '@client/app/core/constants/api.constant';

@Component({
    selector: 'table-page-size',
    template: `
        <div class="btn-group" *ngIf="showPaginate()">
            <a *ngFor="let pageSize of pageSizes; trackBy: trackByIndex"
                role="button"
                [attr.aria-label]="('Page size' | translate) + ' ' + pageSize"
                class="btn btn-default btn-secondary"
                [ngClass]="{'active':pageSize.toString() === currentPageSize.toString()}"
                (click)="selectPageSize(pageSize)">
                {{pageSize}}
            </a>
        </div>
    `,
    standalone: false,
})
export class TablePageSizeComponent implements OnInit, OnChanges {
    @Input() pageSize: string | number = '';
    @Input() pageSizes: string[] = ['10', '25', '50'];
    @Input() totalItems: number = 0;
    @Output() onPerPageChange = new EventEmitter<string>();

    orgPageSizes: string[] = [];
    currentPageSize: string = '';

    ngOnInit (): void {
        this.activate();
    }

    ngOnChanges (): void {
        if (this.orgPageSizes.length > 0) {
            this.setPageSizes();
        }
        this.currentPageSize = this.pageSize.toString();
    }

    activate (): void {
        this.orgPageSizes = [];
        this.currentPageSize = this.pageSize.toString() || API_CONSTANTS.PAGE_SIZE.toString();
        this.orgPageSizes = [...this.pageSizes].sort((a, b) => Number(a) - Number(b));
    }

    showPaginate (): boolean {
        return Number(this.pageSizes[0]) < Number(this.totalItems);
    }

    selectPageSize (pageSize: string): void {
        this.currentPageSize = pageSize;
        this.onPerPageChange.emit(pageSize);
    }

    trackByIndex (index: number): number {
        return index;
    }

    private setPageSizes (): void {
        const collectionCount = parseInt(this.totalItems.toString(), 10);

        this.pageSizes = this.orgPageSizes.filter((pageSize, i) => {
            return parseInt(pageSize) <= collectionCount || (i > 0 && Number(this.orgPageSizes[i - 1]) < collectionCount);
        });
    }
}
